<script setup lang="ts">
import { navigationActions } from "@/action/navigationActions";
import { action } from "@/components/action/action";
import IconButton from "@/components/ui/IconButton/IconButton.vue";

import KebabMenu from "./KebabMenu.vue";
</script>

<template>
  <div class="backlog-menu">
    <IconButton v-bind="action(navigationActions.showKanban)" />
    <KebabMenu :tooltip="$t('label.backlogBoardMenu')" mode="backlog" data-testid="kebab-menu" />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/a11y";
@use "@/styles/board";

.backlog-menu {
  position: absolute;
  right: board.len(12px);
  top: board.len(12px);
  display: flex;
  align-items: center;
  transform-origin: top right;
  transform: scale(8);

  // fix excessive line height
  :deep(.base-tooltip) {
    font-size: initial;
  }
}
</style>
